module.exports = __webpack_public_path__ + "static/media/The-Heights-at-Elkow-Farms-Disclosure-Statement.150f8369.pdf";